import { Dispatch } from "@reduxjs/toolkit";
import { setBMSR, toggleRider } from "../../features/gms-proposal-forms/attachable-rider/attachable-riders.slice";
import { addRiderLevelRankingInput } from "../../features/gms-proposal-forms/coverage/level-ranking/coverage-type-level-ranking.slice";
import { addRiderUniformCoverageInput } from "../../features/gms-proposal-forms/coverage/uniform-coverage/coverage-type-uniform-coverage.slice";
import { addRiderSalaryRankInput } from "../../features/gms-proposal-forms/coverage/salary-rank/coverage-type-by-salary-rank.slice";
import { PROPOSAL_RIDERS } from "../../constant/gms-constant";
import { Riders } from "../../api/gms/proposal/proposal-api-state";
import { pa_addRiderLevelRankingInput, pa_addRiderUniformCoverageInput, pa_addRiderSalaryRankInput, pa_setBMSR, pa_setSelectedRiders } from "../../features/propose-data/propose-data-slice";

export const populateRidersUniformCoverage = (
    dispatch: Dispatch, 
    coverageLabel: string | undefined, 
    riders: Riders[], type: "current" | "proposed", 
    optionForGroupDengueRider?: { id: number; fAmount: number; label: string }[]
) => {
    riders.forEach((rider) => {
        const riderData = { id: rider.rider_id, label: rider.rider_name };

        if (type === "current") {
            dispatch(toggleRider(riderData));
        }
        // if (type === "proposed") dispatch(pa_setSelectedRiders(riderData));
    });

    riders.forEach((rider) => {
        const dynamicInputs = [{ 
            label: coverageLabel ?? "", 
            fAmount: rider.amount ?? 0 
        }];
        const riderData = { 
            id: rider.rider_id, 
            label: rider.rider_name, 
            inputs: dynamicInputs 
        };

        if (type === "current") {
            dispatch(addRiderLevelRankingInput(riderData));
        }
        if (type === "proposed") {
            dispatch(pa_addRiderLevelRankingInput(riderData));
        }
    });

    const uniformRidersArray = riders.map((rider) => ({ 
        id: rider.rider_id, 
        label: rider.rider_name, 
        rider: { fAmount: rider.amount ?? 0, label: "" } 
    }));

    if (type === "current") {
        dispatch(addRiderUniformCoverageInput(uniformRidersArray));
    }
    if (type === "proposed") {
        dispatch(pa_addRiderUniformCoverageInput(uniformRidersArray));
    }

    riders.forEach((rider) => {
        const salaryRankRiderInput = { 
            id: rider.rider_id, 
            label: rider.rider_name 
        };

        if (type === "current") {
            dispatch(addRiderSalaryRankInput(salaryRankRiderInput));
        }
        if (type === "proposed") {
            dispatch(pa_addRiderSalaryRankInput(salaryRankRiderInput));
        }
    });

    const riderMap: Record<string, number> = { 
        BMSR_GYRT: PROPOSAL_RIDERS.BMSR.productFor.GYRT, 
        BMSR_GCI: PROPOSAL_RIDERS.BMSR.productFor.GCI 
    };
    const riderBMSRGYRT = riders.find((rider) => rider.rider_id === riderMap.BMSR_GYRT);
    const riderBMSRGCI = riders.find((rider) => rider.rider_id === riderMap.BMSR_GCI);

    const bmsrData = { 
        id: riderBMSRGYRT?.rider_id ?? riderBMSRGCI?.rider_id ?? 0, 
        label: riderBMSRGYRT?.rider_name ?? riderBMSRGCI?.rider_name ?? "", 
        inputs: [{ fAmount: riderBMSRGYRT?.amount ?? riderBMSRGCI?.amount ?? 0 }] 
    };

    if (type === "current") dispatch(setBMSR(bmsrData));
    if (type === "proposed") dispatch(pa_setBMSR(bmsrData));
};